import {reactive} from 'vue';

export const formValues = reactive({});

export function setFormValue(code, value) {
    formValues[code] = value;
}

export function getFormValue(code) {
    return formValues[code];
}
